import { Country } from '../models/GeneralTypes'
import { numberToEuro } from './Helpers'

export const getCurrencySymbolByCode = (currencyCode: string): string => {
  const currencyMap: { [key: string]: string } = {
    eur: '€',
    gbp: '£',
    usd: '$',
    chf: '€'
  }
  return currencyMap[currencyCode.toLowerCase()] || ''
}

export const getCurrencySymbolByCountry = (country: string): string => {
  const currencyMap: { [key in Country]: string } = {
    de: '€',
    at: '€',
    ch: '€',
    gb: '£'
  }
  return currencyMap[country] || ''
}

export const formatPrice = (price: number, currency: string) => {
  return currency === '£' ? `${currency}${price}` : `${price}${currency}`
}